import React from "react";
import GoogleLanguageSelector from "../../../utils/GoogleLanguageSelector";
import GoogleTranslate from '../../../utils/GoogleTranslate'; // adjust path as needed
function PageTitle({section}) {
  return (
    <div className="page-title border" data-aos="fade">
      <div className="container d-lg-flex justify-content-between align-items-center">
        
        
          {(section !== 'Home' && section !== 'read' && section !== undefined) && <>
          <h6 className="mb-2 mb-lg-0">{section}</h6>
          <nav className="breadcrumbs mb-2 mb-lg-0">
          <ol>
            <li><a href="/">Home</a></li>
            <li className="current">{section}</li>
          </ol>
          </nav>
          </>}
          
        
        <div className="d-flex align-items-center gap-2">
          <GoogleLanguageSelector />
          <GoogleTranslate />
        </div>
      </div>
    </div>
  );
}

export default PageTitle;
